// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3EwLz","rightAdornment":"Header_rightAdornment__28U5W"};